import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { routes, serialNumber, strings, doAmountFormat, doDateFormatWithTime, handleFilters, getSortIcon, stock_status, capitalize } from 'utils';
import { _Object } from 'utils/interfaces';
import { categoryService, productService } from 'services';
import { Button, SearchField, LinkButton, Pagination, TabsHeader, Breadcrumbs, ActiveFilters, SEOHeader, SelectField } from 'views/components';
import { useFormik } from 'formik';
import { Link } from 'react-router-dom';
import { AsyncSelectField } from 'views/components/form-inputs';

const ProductsList = () => {
  const { t } = useTranslation()
  const selectAsyncSelect = React.useRef<any>(null);

  const [loading, setLoading] = useState<_Object>(
    {
      listing: false,
      edit: false,
      update: false
    });
  const [products, setProducts] = useState<_Object>([])
  const [filterdLabel, setFilteredLabel] = useState<_Object>({})
  const [filterApply, setFilterApply] = useState<boolean>(false)
  const [categories, setCategories] = useState<_Object[]>([])
  const [filterData, setFilterData] = useState<_Object>({
    page: 1,
    per_page: process.env.REACT_APP_PER_PAGE,
    sort: '-created_at',
    filter: {
      stock_status: '',
      category_id: '',
    }
  })

  const handleCallApi = () => {
    setLoading({ listing: true });

    productService.getProducts({ ...filterData, q: formik.values.q }).then((data: _Object) => {
      setProducts(data);
      setLoading({ listing: false });
    });
  };

  const formik = useFormik({
    initialValues: { q: '' },
    enableReinitialize: true,
    onSubmit: () => {
      handleCallApi();
    }
  });

  useEffect(() => {
    handleCallApi();
  }, [filterApply]);

  useEffect(() => {
    if (formik.values.q.trim() === '') {
      handleCallApi();
    }
  }, [formik.values.q]);

  useEffect(() => {
    categoryService.getCategories({ per_page: 1000 }).then((data: _Object) => {
      if (data?.items) {
        setCategories(data.items)
      }
    })
  }, [])

  const deleteItem = (idToDelete: string) => {
    if (window.confirm('Are you sure to delete this item?')) {
      setLoading({ listing: true })
      productService.deleteProduct(idToDelete).then(() => {
        productService.getProducts(filterData).then((data: _Object) => {
          setLoading({ listing: false })
          if (data?.items) {
            setProducts(data)
          }
        })
      })
    }
  }

  const loadOption = (inputValue: string) => {
    return categoryService.getCategories({ q: inputValue }).then((res: _Object) => {
      return res.items.map((item: _Object) => ({
        label: item.name,
        value: item.id
      }))
    })
  }

  return (
    <>
      <SEOHeader title="Products" />
      <Breadcrumbs
        trails={[
          {
            label: t('product.products'),
            path: ''
          }
        ]}
      />

      <TabsHeader />

      <div className="d-sm-flex align-items-center justify-content-sm-between justify-content-start gap-2 mb-3">
        <div className="d-flex header-loading">
          <form onSubmit={formik.handleSubmit}>
            <SearchField
              type="search"
              name="q"
              disabled={!formik.values.q}
              className="mb-md-0"
              value={formik.values.q}
              onChange={(e: _Object) => {
                // if (e.target.value === '') {
                //   handleCallApi()
                // }
                console.log(e.target.value);

                formik.setFieldValue('q', e.target.value)
              }}
            />
          </form>
          <button className="btn btn-secondary p-2 px-2.5 ms-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#Orderlist" aria-controls="offcanvasRight">
            <svg className="mx-0" xmlns="http://www.w3.org/2000/svg" version="1.1" width="20" height="20" x="0" y="0" viewBox="0 0 512 512"><g><path d="M16 133.612h260.513c7.186 29.034 33.45 50.627 64.673 50.627s57.487-21.593 64.673-50.627H496c8.836 0 16-7.164 16-16s-7.164-16-16-16h-90.142c-7.185-29.034-33.449-50.628-64.673-50.628s-57.488 21.594-64.673 50.628H16c-8.836 0-16 7.164-16 16s7.164 16 16 16zm325.186-50.628c19.094 0 34.628 15.534 34.628 34.627 0 19.094-15.534 34.628-34.628 34.628s-34.628-15.534-34.628-34.628c0-19.093 15.534-34.627 34.628-34.627zM16 272h90.142c7.186 29.034 33.449 50.627 64.673 50.627s57.487-21.593 64.673-50.627H496c8.836 0 16-7.164 16-16s-7.164-16-16-16H235.487c-7.186-29.034-33.449-50.628-64.673-50.628S113.327 210.966 106.141 240H16c-8.836 0-16 7.164-16 16s7.163 16 16 16zm154.814-50.628c19.094 0 34.628 15.534 34.628 34.628 0 19.093-15.534 34.627-34.628 34.627S136.186 275.093 136.186 256c0-19.094 15.534-34.628 34.628-34.628zM496 378.388h-90.142c-7.186-29.034-33.449-50.628-64.673-50.628s-57.487 21.594-64.673 50.628H16c-8.836 0-16 7.164-16 16s7.164 16 16 16h260.513c7.186 29.034 33.449 50.628 64.673 50.628s57.487-21.594 64.673-50.628H496c8.836 0 16-7.164 16-16s-7.163-16-16-16zm-154.814 50.628c-19.094 0-34.628-15.534-34.628-34.628s15.534-34.628 34.628-34.628 34.628 15.534 34.628 34.628-15.534 34.628-34.628 34.628z" fill="#fff" opacity="1" data-original="#fff"></path></g></svg>
          </button>
          <div className="d-flex align-items-center order-button-list ms-3">
            {Object.values(filterData).some(value => !!value) && (
              <ActiveFilters filterdLabel={filterdLabel} setFilteredLabel={setFilteredLabel} setFilterData={setFilterData} filterData={filterData} setFilterApply={setFilterApply} />
            )}
          </div>

          <span className={`ms-4 ${loading.listing === true ? 'is-loading' : ''}`} />
        </div>

        {Object.values(filterData.filter).some(value => !!value) && (
          <ActiveFilters filterdLabel={filterdLabel.filter} setFilteredLabel={setFilteredLabel} setFilterData={setFilterData} />
        )}

        <div
          className="d-flex justify-content-between justify-content-sm-start align-items-center gap-2"
          style={{
            width: window.innerWidth < 576 ? '100%' : 'auto'
          }}
        >
          <Link
            to={`${routes.products}/import`}
            className="primary text-decoration-none"
          >
            {t('product.import')}
          </Link>

          <LinkButton className="primary" path={`${routes.createProduct}`} label="">
            <i className="fa-solid fa-plus text-white"></i>
            {t('product.add')}
          </LinkButton>
        </div>
      </div>

      {/* <div className="card border-0 my-3">
        <div className={`table-responsive ${loading.listing === false && products?.items?.length ? '' : 'table-not'}`}>
          <table className="card-body mb-0 table table-borderless table-striped order-listing"> */}

      <div className="card border-0 my-3 position-relative">
        <div className={`table-responsive ${loading.listing === false && products?.items?.length ? '' : 'table-not'}`}>
          <table
            className="table table-borderless table-striped order-listing w-100"
            style={{ minWidth: '900px' }}
          >
            <thead>
              <tr className="bg-white">
                <th>#</th>
                {/* <th style={{ width: '8rem' }} className="sku">SKU</th> */}
                <th>
                  <button
                    className="btn p-0 border-0"
                    onClick={() => { handleFilters('sort', filterData.sort === '-name' ? 'name' : '-name', setFilterData) }}>
                    {t('common.title')}
                    {getSortIcon(filterData.sort.includes('name') ? filterData.sort : '')}
                  </button>
                </th>
                <th>{t('common.price')}</th>
                <th>
                  {t('common.stock')}
                </th>

                <th>
                  {t('category.category')}
                </th>

                <th>
                  <button
                    className="btn p-0 border-0"
                    onClick={() => { handleFilters('sort', filterData.sort === '-created_at' ? 'created_at' : '-created_at', setFilterData) }}>
                    {t('common.createDate')}
                    {getSortIcon(filterData.sort.includes('created_at') ? filterData.sort : '')}
                  </button>
                </th>

                <th>
                  <button
                    className="btn p-0 border-0"
                    onClick={() => { handleFilters('sort', filterData.sort === '-updated_at' ? 'updated_at' : '-updated_at', setFilterData) }}>
                    {t('common.updateDate')}
                    {getSortIcon(filterData.sort.includes('updated_at') ? filterData.sort : '')}
                  </button>
                </th>

                <th className="action">{t('common.action')}</th>
              </tr>
            </thead>

            <tbody>
              {products?.items?.map((item: _Object, i: number) => {
                return (
                  <tr key={i}>
                    <td>{serialNumber(filterData.per_page, products?.pagination?.current_page, i)}</td>
                    <td className="break-spaces">
                      {item?.name}
                      <small className="d-block text-secondary">
                        Sku: {item?.sku} | {item.barcode}
                        {item.product_type && (
                          <span
                            className="badge bg-light text-dark border ms-1"
                            style={{ fontSize: '10px' }}
                          >
                            {item.product_type === 'composite' || item.product_type === 'recipe_based'
                              ? 'Composite'
                              : item.product_type === 'raw_material'
                              ? 'Raw Material'
                              : 'Finished Good'}
                          </span>
                        )}
                        {item.is_sale_enabled === false && (
                          <span
                            className="badge bg-danger-subtle text-danger border ms-1"
                            style={{ fontSize: '10px' }}
                          >
                            Not for sale
                          </span>
                        )}
                      </small>
                    </td>
                    <td>
                      {item?.discounted_price ?
                        <>
                          <del>{doAmountFormat(item?.regular_price)}</del><br />
                          <span>{doAmountFormat(item?.discounted_price)}</span>
                        </>
                        :
                        doAmountFormat(item?.regular_price)
                      }
                    </td>

                    <td>
                      {item.manage_stock === true || item.manage_stock === 'true' ? (
                        <div>
                          <div className="d-flex align-items-center gap-1">
                            <span
                              className={`badge ${
                                Number(item.stock) <= 0
                                  ? 'bg-danger'
                                  : item.low_stock_threshold && Number(item.stock) <= Number(item.low_stock_threshold)
                                  ? 'bg-warning text-dark'
                                  : 'bg-success'
                              }`}
                            >
                              {Number(item.stock) <= 0
                                ? 'Out of stock'
                                : item.low_stock_threshold && Number(item.stock) <= Number(item.low_stock_threshold)
                                ? 'Low stock'
                                : 'In stock'}
                            </span>
                          </div>
                            <span className="fw-bold ms-1">
                              {Number(item.stock) || 0} {item.stock_unit || ''}
                            </span>
                          {item.location_wise_stock && Object.keys(item.location_wise_stock).length > 1 && (
                            <small className="text-muted d-block" style={{ fontSize: '11px' }}>
                              {Object.keys(item.location_wise_stock).length} locations
                            </small>
                          )}
                        </div>
                      ) : (
                        <div>
                          <span className={`badge ${item.stock_status === 'instock' ? 'bg-success' : 'bg-danger'}`}>
                            {stock_status(item.stock_status)}
                          </span>
                          {Number(item.stock) > 0 && (
                            <span className="ms-1 fw-bold">
                              : {Number(item.stock)} {item.stock_unit || ''}
                            </span>
                          )}
                        </div>
                      )}
                    </td>
                    {/* <td>
                    {item?.categories?.map((categoriesItem: _Object, k: number) => {
                      return (
                        <span className="d-block mb-1" key={k}>{categoriesItem?.name}</span>
                      )
                    })}
                  </td> */}
                    {/* <td>{item?.brand?.name}</td> */}

                    <td>
                      {item?.category?.name || '-'}

                      {/* {item?.suppliers &&
                        item.suppliers.map((suppliersItem: _Object, l: number) => (
                          <span className="d-block mb-1" key={l}>{suppliersItem?.name}</span>
                        )) || '-'
                      } */}
                    </td>

                    <td>{doDateFormatWithTime(item.created_at)}</td>
                    <td>{doDateFormatWithTime(item.updated_at)}</td>
                    <td>
                      <ul className="list-inline">
                        <li className="list-inline-item">
                          <LinkButton
                            path={`${routes.products}/edit/${item.id}`}
                            className="link text-dark p-0"
                            label={''}>
                            <i className="fa fa-pen"></i>
                          </LinkButton>
                        </li>
                        <li className="list-inline-item">
                          <Button type="submit" className="link text-dark p-0" onClick={() => deleteItem(item.id)}>
                            <i className="fa fa-trash text-danger"></i>
                          </Button>
                        </li>
                      </ul>
                    </td>
                  </tr>
                );
              })}
              {loading.listing === false && products?.items?.length === 0 &&
                <tr>
                  <td colSpan={8} className="text-center no-entry">
                    <aside>
                      <i className="fa-solid fa-ban"></i>
                      {strings.noRecordFound}
                    </aside>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      {products?.pagination?.total_pages > 1 &&
        <Pagination
          current_page={products?.pagination?.current_page}
          per_page={products?.pagination?.per_page}
          total_pages={products?.pagination?.total_pages}
          total_items={products?.pagination?.total_items}
          onClick={(i: { [key: string]: number }) =>{
            setFilterData((prev) => ({
              ...prev,
              page: i.selected + 1,
            }))
            setFilterApply((prev: boolean) => !prev);
          }
          }
        />
      }

      <div className="offcanvas offcanvas-end" id="Orderlist" aria-labelledby="OrderlistLabel">
        <div className="offcanvas-header border-bottom">
          <h5 className="offcanvas-title" id="OrderlistLabel"><strong>Fillter</strong></h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div className="offcanvas-body">

          <div className="col-12">

            <div className="card-body">
              <form>
                <div className="row">
                  <AsyncSelectField
                    isClearable
                    isMulti
                    cacheOptions
                    label={`${t('category.categories')}`}
                    name="category_id"
                    placeholder={t('common.choose_option')}
                    loadOptions={loadOption}
                    ref={(ref: any) => (selectAsyncSelect.current = ref)}
                    defaultOptions={categories?.map((item: _Object) => ({
                      label: capitalize(item.name),
                      value: item.id
                    }))}
                    onChange={(val: any) => {
                      const selectedIds = Array.isArray(val) ? val.map((item: any) => item.value) : [];
                      setFilterData((prev: any) => {
                        const updatedFilter = { ...(prev.filter || {}) };

                        if (!selectedIds.length) {
                          delete updatedFilter.category_id;
                        } else {
                          updatedFilter.category_id = selectedIds;
                        }
                        return {
                          ...prev,
                          filter: updatedFilter,
                        };
                      });
                      setFilteredLabel((prev: any) => {
                        const updated = { ...(prev || {}) };
                        if (!selectedIds.length) {
                          delete updated.category_id;
                          return updated;
                        }
                        updated.category_id = val.map((x: any) => x.label).join(', ');
                        return updated;
                      });
                    }}
                    value={
                      categories
                        ?.map((item: _Object) => ({ label: capitalize(item.name), value: item.id }))
                        .filter((opt: any) =>
                          (filterData.filter?.category_id || []).includes(opt.value)
                        ) || []
                    }
                  />

                  <SelectField
                    name="text"
                    label={t('Sort by')}
                    className="col-12"
                    options={[
                      { value: '-created_at', label: 'Created ↓ (Newest)' },
                      { value: 'created_at', label: 'Created ↑ (Oldest)' },
                      { value: '-updated_at', label: 'Updated ↓ (Newest)' },
                      { value: 'updated_at', label: 'Updated ↑ (Oldest)' },
                      { value: 'name', label: 'Title (A-Z)' },
                      { value: '-name', label: 'Title (Z-A)' },
                    ]}
                    onChange={(e: _Object) => {
                      setFilterData((prev: any) => ({
                        ...prev,
                        sort: e.value,
                      }));
                    }}
                  />
                  <div className="col-12">
                    <Button
                      type="button"
                      onClick={() => setFilterApply(!filterApply)}
                      className="primary mx-auto"
                      data-bs-dismiss="offcanvas" aria-label="Close"
                    >
                      Apply Filters
                    </Button>
                    <Button
                      type="button"
                      onClick={() => {
                        setFilterData({
                          page: 1,
                          per_page: process.env.REACT_APP_PER_PAGE,
                          sort: '-created_at',
                          filter: {
                            stock_status: '',
                            category_id: '',
                          }
                        });
                        setFilteredLabel({});
                        formik.setFieldValue('q', '');
                        setFilterApply(!filterApply);
                      }}
                      className="secondry text-danger mx-auto"
                      data-bs-dismiss="offcanvas" aria-label="Close"
                    >
                      Clear All
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div >
      </div >
    </>
  )
}
export default ProductsList
